module.exports = __webpack_public_path__ + "img/COQUI.a4bdc916.svg";